<template>
  <v-app-bar app color="primary" dark flat>
    <v-toolbar-title class="align-center">
      <span class="title text-capitalize">Nikah Connect</span>
    </v-toolbar-title>
    <v-spacer />
    <UserMenu />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import Notifications from "./Notifications";
// import memberService from "@/modules/Member/service.js";
// import AutoComplete from "@/modules/Member/components/AutoComplete"
import UserMenu from "./Menu";
export default {
  data() {
    return {
      loading: false,
      customerSearch: null,
    };
  },
  components: {
    UserMenu,
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
  },
  methods: {
    ...mapActions("layout", ["drawerToggle"]),
    goHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
    // getMemberList() {
    //   this.loading = true;
    //   return memberService.getAll().then(response => {
    //     this.loading = false;
    //     this.Member = response.data;
    //     return response;
    //   });
    // }
  },
};
</script>
